interface IEpsNode {
  code: string
  isIncluded: boolean
  id: number
  uid: string
  createdOn: Date
}
interface ISite {
  id: number
  code: string
  name: string
  timeZoneName: string
  country: string
  region: string
  shiftStartTime: number
  shiftEndTime: number
  startOfWeek: 0 | 2 | 1 | 3 | 4 | 5 | 6 | undefined
  utcOffset: number
  dateFormat: number
  timeFormat: number
  epsNodes: IEpsNode[]
  createdOn: Date
}

interface IFeatureSetting {
  key: string
  description: string
  defaultValue: string
  valueType: string
  inputType: string
  options?: string
  featureFlagId: number
  category?: string
}

interface IFeatureSettingsValue {
  id: number
  key: string
  value?: string
}

interface IFeatureToggle {
  featureFlagId: number
  category: string
  description: string
  isActive: boolean
  featureSettings: IFeatureSetting[]
  featureSettingsValues: IFeatureSettingsValue[]
  key: string
  isEnabled: boolean
}

interface IMockedSettings {
  site: ISite
  featureToggles: IFeatureToggle[]
  updatedBy: string
  updatedOn: Date
}

export const mockedSiteSettings: IMockedSettings = {
  site: {
    name: 'Billings Refinery',
    code: 'BIR',
    timeZoneName: 'Mountain Standard Time',
    country: 'United States',
    region: 'NA',
    shiftStartTime: 7,
    shiftEndTime: 17,
    startOfWeek: 5,
    utcOffset: -6,
    dateFormat: 3,
    timeFormat: 1,
    epsNodes: [
      {
        uid: 'f8713b54-5fb2-45c0-b35c-93a9110a7b1e',
        code: 'BIL',
        isIncluded: true,
        id: 0,
        createdOn: new Date(),
      },
    ],
    id: 4,
    createdOn: new Date(),
  },
  featureToggles: [
    {
      featureFlagId: 1,
      category: 'ISTe Import',
      description: 'Auto Split tasks during Import',
      isActive: true,
      featureSettings: [],
      featureSettingsValues: [],
      key: 'import:splitTasks',
      isEnabled: false,
    },
    {
      featureFlagId: 2,
      category: 'Digital Scaffolding integration',
      description: 'Read integration',
      isActive: true,
      featureSettings: [],
      featureSettingsValues: [],
      key: 'web:scaffolding:read',
      isEnabled: false,
    },
    {
      featureFlagId: 3,
      category: 'Digital Scaffolding integration',
      description: 'Auto off-rent integration',
      isActive: true,
      featureSettings: [],
      featureSettingsValues: [],
      key: 'web:scaffolding:offrent',
      isEnabled: false,
    },
    {
      featureFlagId: 4,
      category: 'Beta features',
      description: 'Enable mass edit Tasks when change StartTime',
      isActive: true,
      featureSettings: [],
      featureSettingsValues: [],
      key: 'web:taskStartTime',
      isEnabled: false,
    },
    {
      featureFlagId: 5,
      category: 'Digital Scaffolding integration',
      description: 'Potential Barriers',
      isActive: true,
      featureSettings: [
        {
          key: 'scaffolding:potentialBarriers:version',
          description: 'Version',
          defaultValue: 'v1',
          valueType: 'string',
          inputType: 'select',
          options: 'Version 1=v1|Version 2=v2',
          featureFlagId: 5,
        },
        {
          key: 'scaffolding:potentialBarriers:version2',
          description: 'Select 2',
          defaultValue: 'build',
          valueType: 'string',
          inputType: 'select',
          options: 'Build=build|Demo=demo',
          category: 'scaffolding',
          featureFlagId: 5,
        },
        {
          key: 'pb:textabc',
          description: 'PB ABC',
          defaultValue: 'abc',
          valueType: 'string',
          inputType: 'text',
          category: 'scaffolding',
          featureFlagId: 5,
        },
        {
          key: 'pb:numbertestxx',
          description: 'Numbers only',
          defaultValue: '123',
          valueType: 'number',
          inputType: 'text',
          category: 'Numbers',
          featureFlagId: 5,
        },
        {
          key: 'pb:numbertestxx2',
          description: 'Numbers only',
          defaultValue: '',
          valueType: 'number',
          inputType: 'text',
          category: 'Numbers',
          featureFlagId: 5,
        },
      ],
      featureSettingsValues: [
        {
          id: 170,
          key: 'pb:textabc',
          value: 'abc',
        },
        {
          id: 171,
          key: 'pb:numbertestxx',
          value: '123',
        },
        {
          id: 172,
          key: 'pb:numbertestxx2',
        },
        {
          id: 645,
          key: 'scaffolding:potentialBarriers:version2',
          value: 'build',
        },
        {
          id: 646,
          key: 'scaffolding:potentialBarriers:version',
          value: 'v1',
        },
      ],
      key: 'scaffolding:potentialBarriers',
      isEnabled: true,
    },
    {
      featureFlagId: 17,
      category: 'SAP Import',
      description: 'SAP Integration',
      isActive: true,
      featureSettings: [
        {
          key: 'sap:import:settings:baseUrl',
          description: 'BaseURL',
          defaultValue: '',
          valueType: 'string',
          inputType: 'text',
          category: 'Proxy API',
          featureFlagId: 17,
        },
        {
          key: 'sap:import:settings:serviceName',
          description: 'Service Name',
          defaultValue: '',
          valueType: 'string',
          inputType: 'select',
          options:
            'STRIPES=YI_DM_GENERAL_WO_API_SRV|GEMS=YPM_DM_GENERAL_WO_API_SRV',
          category: 'Proxy API',
          featureFlagId: 17,
        },
        {
          key: 'sap:import:settings:endpoint',
          description: 'Endpoint',
          defaultValue: '',
          valueType: 'string',
          inputType: 'text',
          category: 'Proxy API',
          featureFlagId: 17,
        },
        {
          key: 'sap:import:settings:expand',
          description: 'Expand',
          defaultValue: '',
          valueType: 'string',
          inputType: 'text',
          category: 'Proxy API',
          featureFlagId: 17,
        },
        {
          key: 'sap:import:settings:param:Maintplant',
          description: 'Param Maintplant',
          defaultValue: '',
          valueType: 'string',
          inputType: 'text',
          category: 'Proxy API',
          featureFlagId: 17,
        },
        {
          key: 'sap:import:settings:param:Userstatus',
          description: 'Param Userstatus',
          defaultValue: '',
          valueType: 'string',
          inputType: 'text',
          category: 'Proxy API',
          featureFlagId: 17,
        },
        {
          key: 'sap:import:settings:automatic',
          description: 'Run automatically?',
          defaultValue: 'false',
          valueType: 'boolean',
          inputType: 'checkbox',
          category: 'Automation',
          featureFlagId: 17,
        },
        {
          key: 'sap:import:settings:schedule',
          description: 'Automatic schedule',
          defaultValue:
            'EVERY last mon IMPORT FROM next month TO NEXT 1 months',
          valueType: 'string',
          inputType: 'text',
          category: 'Automation',
          featureFlagId: 17,
        },
        {
          key: 'sap:import:settings:sapSystem',
          description: 'SAP System Code',
          defaultValue: 'G9P',
          valueType: 'string',
          inputType: 'select',
          options: 'G9P=G9P|STRIPES AMP=AMP|STRIPES EUP=EUP|STRIPES APP=APP',
          category: 'Proxy API',
          featureFlagId: 17,
        },
        {
          key: 'sap:import:settings:origin',
          description: 'Origin',
          defaultValue: '',
          valueType: 'string',
          inputType: 'select',
          options:
            'NONE=|NASTRIPES=;o=NASTRIPES|EUSTRIPES=;o=EUSTRIPES|APSTRIPES=;o=APSTRIPES',
          category: 'Proxy API',
          featureFlagId: 17,
        },
      ],
      featureSettingsValues: [
        {
          id: 173,
          key: 'sap:import:settings:baseUrl',
        },
        {
          id: 174,
          key: 'sap:import:settings:endpoint',
          value: 'sf',
        },
        {
          id: 175,
          key: 'sap:import:settings:expand',
          value: 'werwe',
        },
        {
          id: 176,
          key: 'sap:import:settings:param:Maintplant',
        },
        {
          id: 177,
          key: 'sap:import:settings:param:Userstatus',
        },
        {
          id: 178,
          key: 'sap:import:settings:schedule',
          value: 'EVERY last mon IMPORT FROM next month TO NEXT 1 months',
        },
        {
          id: 641,
          key: 'sap:import:settings:origin',
          value: ';o=NASTRIPES',
        },
        {
          id: 642,
          key: 'sap:import:settings:sapSystem',
          value: 'G9P',
        },
        {
          id: 643,
          key: 'sap:import:settings:serviceName',
        },
        {
          id: 644,
          key: 'sap:import:settings:automatic',
          value: 'false',
        },
      ],
      key: 'sap:import',
      isEnabled: false,
    },
    {
      featureFlagId: 19,
      category: 'SAP Import',
      description: 'Midstream Process',
      isActive: true,
      featureSettings: [
        {
          key: 'sap:midstreamProcess:abcIndicator:criticality',
          description: 'Criticality',
          defaultValue: '',
          valueType: 'string',
          inputType: 'text',
          category: 'abc Indicator',
          featureFlagId: 19,
        },
        {
          key: 'sap:midstreamProcess:abcIndicator:description',
          description: 'Description',
          defaultValue: '',
          valueType: 'string',
          inputType: 'text',
          category: 'abc Indicator',
          featureFlagId: 19,
        },
      ],
      featureSettingsValues: [
        {
          id: 753,
          key: 'sap:midstreamProcess:abcIndicator:description',
        },
      ],
      key: 'sap:midstreamProcess',
      isEnabled: false,
    },
    {
      featureFlagId: 21,
      category: 'App Version',
      description: 'DWS Next',
      isActive: true,
      featureSettings: [],
      featureSettingsValues: [],
      key: 'web:version',
      isEnabled: true,
    },
    {
      featureFlagId: 22,
      category: 'ISTe Import',
      description: 'Import Engine V2',
      isActive: true,
      featureSettings: [],
      featureSettingsValues: [],
      key: 'iie:import:v2',
      isEnabled: false,
    },
  ],
  updatedBy: 'John, Doe',
  updatedOn: new Date(),
}
